import { getQiniuToken } from '../api/login';
import { imgDomain } from '../configs/env'

export default {
  data() {
    return {
      imgDomain,
      uploadData: {
        token: '',
        saveKey: '',
        key: '',
      },
    };
  },
  created() {
    this.getQiniuToken();
  },
  methods: {
    beforeAvatarUploadImages(file) {
      console.log(file);
      this.uploadData.saveKey = file.name
      this.uploadData.key = file.name
    },
    async getQiniuToken() {
      const { status, data } = await getQiniuToken()
      if (status !== 200) return
      this.uploadData.token = data.token
    },
  },
};



// WEBPACK FOOTER //
// ./src/jslib/qiniu.js